/*
 * @Description: common definition for sales channel promotion
 * @Author: Chris
 * @Date: 2021-03-23
 */
import moment from 'moment';
import { IPopUpWindow } from '@/src/types/common/SalesChannel';
// import moment, { Moment } from 'moment';
// import {
//   sorByAscentTime,
//   sortByDesendTime,
// } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/tools';
import { MAX_DATE } from '@/src/types/common/SalesChannel';
import { get } from 'lodash';
import {
  handleOnGetCurrentSCTimezone,
  generateMomentTime,
} from 'src/tools/tools';
const DATE_FORMAT = 'YYYY-MM-DD HH:mm';

export interface IOptionItem {
  label: string;
  value: string;
  disabled: boolean;
}

export enum EnumPromotionCollapseId {
  edm = 'saleChannelContentPromotionEDM',
  featuredProducts = 'saleChannelContentPromotionFeaturedProducts',
  popUpWindow = 'saleChannelContentPromotionPopUpWindow',
}

export enum EnumPromotionSwitch {
  shoppingCart,
  profile,
  productSearch,
  fourZeroFour,
  edmHomePage,
  edmProfile,
}

export enum EnumPromotionField {
  email = 'Email',
  firstName = 'Firstname',
  lastName = 'Lastname',
  dateOfBirth = 'Date of birth',
  gender = 'Gender',
  customField = 'Custom field',
}

export enum EnumCustomAction {
  changeFieldTitle,
  changeCheckbox,
  changeFieldType,
  changeFieldName,
  addOption,
  sortOption,
  deleteOption,
}

export enum EnumPromotionFieldType {
  textField = 'TextField',
  dropdown = 'Dropdown',
}

export enum EnumPromotionEDMAction {
  addSimple,
  addCustom,
  editSimple,
  editCustom,
}

export const enumPromotionFieldConvert = (type: EnumPromotionField): string => {
  if (type === EnumPromotionField.firstName) {
    return EnumPromotionField.firstName;
  } else if (type === EnumPromotionField.gender) {
    return EnumPromotionField.gender;
  } else if (type === EnumPromotionField.lastName) {
    return EnumPromotionField.lastName;
  } else if (type === EnumPromotionField.dateOfBirth) {
    return EnumPromotionField.dateOfBirth;
  } else if (type === EnumPromotionField.customField) {
    return EnumPromotionField.customField;
  }
};

export const getEdmFieldPlaceholder = (category: EnumPromotionField) => {
  if (category === EnumPromotionField.firstName) {
    return 'First name';
  } else if (category === EnumPromotionField.lastName) {
    return 'Last name';
  } else if (category === EnumPromotionField.gender) {
    return 'Gender';
  } else if (category === EnumPromotionField.dateOfBirth) {
    return 'Date of birth | (yyyy-mm-dd)';
  }
};

export const setSwitchTypeState = (switchType, state, isSwitchOn) => {
  if (switchType === EnumPromotionSwitch.shoppingCart) {
    state.featuredProducts.shopCart.checked = isSwitchOn;
  } else if (switchType === EnumPromotionSwitch.profile) {
    state.featuredProducts.profile.checked = isSwitchOn;
  } else if (switchType === EnumPromotionSwitch.productSearch) {
    state.featuredProducts.productSearch.checked = isSwitchOn;
  } else if (switchType === EnumPromotionSwitch.fourZeroFour) {
    state.featuredProducts.fourZeroFour.checked = isSwitchOn;
  } else if (switchType === EnumPromotionSwitch.edmHomePage) {
    state.edm.homePage.checked = isSwitchOn;
  } else if (switchType === EnumPromotionSwitch.edmProfile) {
    state.edm.profilePage.checked = isSwitchOn;
  }
};

export const getPromotionEdmOptionList = (): IOptionItem[] => {
  return [
    {
      label: EnumPromotionField.firstName,
      value: EnumPromotionField.firstName,
      disabled: false,
    },
    {
      label: EnumPromotionField.lastName,
      value: EnumPromotionField.lastName,
      disabled: false,
    },
    {
      label: EnumPromotionField.dateOfBirth,
      value: EnumPromotionField.dateOfBirth,
      disabled: false,
    },
    {
      label: EnumPromotionField.gender,
      value: EnumPromotionField.gender,
      disabled: false,
    },
    {
      label: EnumPromotionField.customField,
      value: EnumPromotionField.customField,
      disabled: false,
    },
  ];
};

export enum EnumPromotionPopWindowType {
  ImageAndLink = 'ImageAndLink',
  EDM = 'EDM',
}

export const getDateOfBirthString = (category, name) => {
  if (category === EnumPromotionField.dateOfBirth && name && name.length) {
    if (!name.endsWith(' | (yyyy-mm-dd)')) {
      return `${name} | (yyyy-mm-dd)`;
    }
  }
  return name;
};

export const checkPopUpWindowError = (data: IPopUpWindow) => {
  const { remark, beginDate, beginTime, image, promotionType } = data;
  if (
    !Boolean(promotionType) ||
    promotionType === EnumPromotionPopWindowType.ImageAndLink
  ) {
    return (
      Boolean(remark) &&
      Boolean(beginDate) &&
      Boolean(beginTime) &&
      Boolean(image)
    );
  } else {
    return Boolean(remark) && Boolean(beginDate) && Boolean(beginTime);
  }
};

export const shiftingDates = (popUpWindowData) => {
  const list = {
    editing: {},
    inUse: [],
    pending: [],
    previous: [],
  };

  const scTimezoneUTC = handleOnGetCurrentSCTimezone();
  const currentTime = moment().tz(scTimezoneUTC);
  const keys = Object.keys(popUpWindowData) || [];
  keys.forEach((key) => {
    const value = popUpWindowData[key];

    if (Array.isArray(value)) {
      value.forEach((item) => {
        handleShiftDate(currentTime, item, list);
      });
    } else {
      handleShiftDate(currentTime, value, list);
    }
  });
  //console.log(list, 'ki');
  return list;
};

export const shiftDate = (currentTime, value, statusList) => {
  const scTimezoneUTC = handleOnGetCurrentSCTimezone();
  const begin = generateMomentTime(
    value.beginDate,
    value.beginTime,
    scTimezoneUTC,
  );
  let end = generateMomentTime(value.endDate, value.endTime, scTimezoneUTC);

  if (!Boolean(value.endDate)) {
    end = moment(MAX_DATE, DATE_FORMAT);
  }

  if (currentTime.isBetween(begin, end)) {
    statusList.inUse.push({ ...value });
  }

  if (currentTime.isAfter(end)) {
    statusList.previous.push({ ...value });
  }

  if (currentTime.isBefore(begin)) {
    statusList.pending.push({ ...value });
  }
};

const handleShiftDate = (currentTime, value, statusList) => {
  if (Object.keys(value).length === 0) {
    return;
  }

  const isValid = checkPopUpWindowError(value);
  const isPrevious = get(value, '_status') === 'previous';

  if (!isValid && !isPrevious) {
    if (!statusList.pending.find((item) => item.id === value.id)) {
      statusList.pending.push({ ...value });
    }
  } else {
    shiftDate(currentTime, value, statusList);
  }
};

export const getPopUpWindowDataById = (popUpWindowData, id) => {
  let targetItem = null;
  const keys = Object.keys(popUpWindowData) || [];
  keys.forEach((key) => {
    const value = popUpWindowData[key];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item.id === id) {
          targetItem = item;
        }
      });
    } else {
      if (value.id === id) {
        targetItem = value;
      }
    }
  });
  return targetItem;
};
